import React from 'react'
import CarrierBrandRemoteOptionsSelectField from '../../common/CarrierBrandRemoteOptionsSelectField'

type Props = {
  handleChange: (field: string, value: string) => void,
  values: {
    [key: string]: string
  }
}

const CarrierBrandFields: React.FC<Props> = ({ handleChange, values }) => {
  return (
    <CarrierBrandRemoteOptionsSelectField
      name="carrier_brands"
      handleChange={handleChange}
      value={values.carrier_brands}
      recordValue="name"
      multi
    />
  )
}

export default CarrierBrandFields
